import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ContentAuthoringService } from 'src/app/services/content-authoring.service';

@Component({
  selector: 'app-ticket-detail',
  templateUrl: './ticket-detail.component.html',
  styleUrls: ['./ticket-detail.component.scss']
})
export class TicketDetailComponent implements OnInit {

  errorInfo: { isError: boolean, errorMsg: string } = { isError: false, errorMsg: '' }
  adminData: any;
  contact_id: any;
  ticketDetail: any;
  status: any;
  closeResult = '';

  constructor(private contentAuthoringApi: ContentAuthoringService,private spinner: NgxSpinnerService, private route: ActivatedRoute,private router: Router,private modalService: NgbModal) { }

  ngOnInit(): void {
    this.adminData = JSON.parse(localStorage.getItem('adminData') || '[]');
    this.route.queryParams.subscribe(params => {
      const id = +params.id;
      this.status= params.status;
      if (id > 0) {
        console.log(id);
        this.contact_id = id
      }
    });
    this.getTicketDetail()
    if(this.status==1){
      this.markResolved(3)
    }
  }
  markResolved(status:any){
    this.spinner.show();
    const postJson = {
      "contact_id":  this.contact_id,
      "status": status
    }
    this.contentAuthoringApi.markResolved(postJson).subscribe(
      (data) => {
        // console.log(data);
        if (data.success) {
          this.spinner.hide();
          if(status==2){
            document.getElementById('successMsg')?.click();
           // alert('Tickect has been resolved successfully')
            this.router.navigate(['./manage-tickets']);
          }
        } else {
          this.spinner.hide();
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'Somthing went wrong'
        }
      },
      (error) => {
        this.spinner.hide();
        this.errorInfo.errorMsg = error;
      },
    );
  }
  getTicketDetail() {
    this.spinner.show();
    const postJson = {
      "contact_id":  this.contact_id,
    }
    this.contentAuthoringApi.ticketDetail(postJson).subscribe(
      (data) => {
        this.spinner.hide();
        this.ticketDetail = data.userData;
      },
      (error) => {
        this.spinner.hide();
        this.errorInfo.errorMsg = error;
      },
    );
  }
  open(content: any) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}
